import React, { useContext } from 'react';
import { ButtonGroup, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Phone, WindowDock } from 'react-bootstrap-icons';

import styles from './ViewSwitch.module.css';
import { ModalContext, WidgetsContext, AppContext, isDemo } from '../../../../GlobalContex';

const TopPanel = ({ activeKey, setKey }) => {
  const { t } = useTranslation();
  const setVariant = key => `${key === activeKey ? '' : 'outline-'}primary`;
  const { modal, setModal } = useContext(ModalContext);
  const { activeWidget } = useContext(WidgetsContext);
  const { isEmbeded } = useContext(AppContext);

  const options = [
    {
      key: 'phone',
      tooltip: 'Phone View',
      icon: Phone
    },
    {
      key: 'desktop',
      tooltip: 'Desktop View',
      icon: WindowDock
    }
  ];

  const addToWebsite = () => {
    setModal({
      open: true,
      body: `Copy and paste this HTML code where you want the widget to appear on your page.<br/><br/><textarea style="width: 100%;">${activeWidget.code}</textarea>`
    });
  };

  const goToRegister = () => {
    const url = 'https://a.electricblaze.com/#/register';
    if (isDemo) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  }

  return (
    <div className={styles.wrapper}>
      <ButtonGroup className={styles.buttons}>
        {options.map((item, i) => {
          return (
            <OverlayTrigger
              key={item.key}
              placement={'bottom'}
              overlay={<Tooltip id={`tooltip-bottom`}>{item.tooltip}</Tooltip>}
            >
              <Button variant={setVariant(item.key)} onClick={() => setKey(item.key)}>
                <item.icon size={24} />
              </Button>
            </OverlayTrigger>
          );
        })}
      </ButtonGroup>
      {activeWidget.id && !isEmbeded() && !isDemo && (
        <Button style={{ margin: '8px' }} onClick={addToWebsite}>
          {t('Add to page')}
        </Button>
      )}
      {isDemo && (
        <Button style={{ margin: '8px' }} onClick={goToRegister}>
          {t('Add to website')}
        </Button>
      )}
    </div>
  );
};

export default TopPanel;
